import { render } from "./LeadMagnets.vue?vue&type=template&id=0cc5cdca&scoped=true"
import script from "./LeadMagnets.vue?vue&type=script&lang=js"
export * from "./LeadMagnets.vue?vue&type=script&lang=js"

import "./LeadMagnets.vue?vue&type=style&index=0&id=0cc5cdca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cc5cdca"]])

export default __exports__